// import React, { useState } from "react";
import classes from "./CheckOutForm.module.scss";
import HeaderB from "../Header/HeaderB";
import GoBackLink from "../GoBacklink/GoBackLink";
import Footer from "../Footer/Footer";
import marktwoImg from "../../assets/shared/desktop/image-xx99-mark-two-headphones.jpg";
import xx59ImgItem from "../../assets/shared/desktop/image-xx59-headphones.jpg";
import earphoneYX1 from "../../assets/product-yx1-earphones/desktop/image-product.jpg";
import { Link } from "react-router-dom";
// import SuccessModal from "./SuccessModal";

const CheckoutForm = ({ priceVal }) => {
  //   const formattedPrice = Number(priceVal).toLocaleString();

  // const [showSuccessModal, setShowSuccessModal] = useState(false);
  // const onSuccessModal = () => {
  //   setShowSuccessModal(true);
  // };

  return (
    <section className={classes.checkOutForm}>
      <HeaderB />
      {/* {showSuccessModal && <SuccessModal />} */}
      <main>
        <section className={classes.body_wrapper}>
          <GoBackLink />
          <section className={classes.checkoutform_body}>
            <form action="#">
              <h1 className={classes.checkout_heading}>Checkout</h1>
              <section className={classes.detail_container}>
                {" "}
                <p className={classes.subheading}>Billing details</p>
                <div className={classes.billing_details}>
                  <div className={`${classes.name} ${classes.groupA}`}>
                    <label htmlFor="">Name</label>
                    <input type="text" placeholder="Alexei Ward" />
                  </div>
                  <div className={`${classes.email_address} ${classes.groupA}`}>
                    <label htmlFor="">Email address</label>

                    <input
                      type="email"
                      placeholder="alexei@mail.com"
                      name="email"
                    />
                  </div>
                  <div className={`${classes.phone_num} ${classes.groupA}`}>
                    <label htmlFor="number">Phone number</label>
                    <input type="number" placeholder="+1 202-555-0136" />
                  </div>
                </div>
              </section>
              <section className={classes.detail_container}>
                {" "}
                <p className={classes.subheading}>Shipping info</p>
                <div className={classes.shipping_info}>
                  <div className={`${classes.address} ${classes.groupA}`}>
                    <label htmlFor="address">Address</label>
                    <input type="text" placeholder="1137 Williams Avenue" />
                  </div>
                  <div className={`${classes.zip_code} ${classes.groupA}`}>
                    <label htmlFor="">ZIP code</label>
                    <input type="number" placeholder="10001" />
                  </div>
                  <div className={`${classes.city} ${classes.groupA}`}>
                    <label htmlFor="">City</label>
                    <input type="text" placeholder="New York" />
                  </div>
                  <div className={`${classes.country} ${classes.groupA}`}>
                    <label htmlFor="">Country</label>
                    <input type="text" placeholder="USA" />
                  </div>
                </div>
              </section>
              <section className={classes.detail_container}>
                <p className={classes.subheading}>Payment details</p>
                <div className={classes.payment_details}>
                  <section className={classes.payment_method}>
                    <label htmlFor="" className={classes.payment_method_label}>
                      Payment method
                    </label>
                    <section className={classes.radio_inputs}>
                      <div className={classes.radio_input}>
                        <input
                          type="radio"
                          name="paymentMethod"
                          className={classes.payment_method_type}
                        />
                        <label htmlFor="">e-Money</label>
                      </div>
                      <div className={classes.radio_input}>
                        <input
                          type="radio"
                          name="paymentMethod"
                          className={classes.payment_method_type}
                        />
                        <label htmlFor="">Cash on delivery</label>
                      </div>
                    </section>
                  </section>
                  <section className={classes.e_money_details}>
                    <div className={`${classes.e_money_num} ${classes.groupA}`}>
                      <label htmlFor="">e-Money number</label>
                      <input type="number" placeholder="238521993" />
                    </div>
                    <div className={`${classes.e_money_pin} ${classes.groupA}`}>
                      <label htmlFor="">e-money PIN</label>
                      <input type="number" placeholder="6891" />
                    </div>
                  </section>
                </div>
                <section
                  className={`${classes.cash_on_delivery} ${classes.payment_method_note}`}
                >
                  <svg
                    width="48"
                    height="48"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M46.594 8.438H42.28c-.448 0-.869.213-1.134.574l-2.694 3.674a1.15 1.15 0 1 1-1.848-1.37c2.568-3.53 2.864-3.545 2.864-4.285 0-.779-.636-1.406-1.407-1.406h-5.404a17.658 17.658 0 0 1 9.606-2.813h4.33a1.406 1.406 0 0 0 0-2.812h-4.33c-5.277 0-10.33 2.02-14.142 5.625h-8.34c-.777 0-1.407.63-1.407 1.406v9.938H9.844c-.777 0-1.406.63-1.406 1.406v15.6a14.053 14.053 0 0 0-7.824 3.089 1.406 1.406 0 1 0 1.772 2.185 11.226 11.226 0 0 1 7.048-2.499h3.129c.775 0 1.406.63 1.406 1.406 0 .776-.631 1.407-1.406 1.407H8.436a1.406 1.406 0 0 0 0 2.812h13.728a4.226 4.226 0 0 1-3.977 2.813H1.405a1.406 1.406 0 0 0 0 2.812h16.782c3.395 0 6.236-2.42 6.89-5.625h7.36c.776 0 1.406-.63 1.406-1.406V25.312h9.843c.777 0 1.407-.63 1.407-1.406V11.25h1.5a1.406 1.406 0 0 0 0-2.813ZM33.61 17.599a1.404 1.404 0 0 0-1.172-.63h-3.085c-1.084-1.834.241-4.172 2.381-4.172 2.531 0 3.708 3.115 1.876 4.802ZM21.188 8.437h14.06c-.744 1.03-1.057 1.305-1.352 1.983-4.216-1.779-8.726 2.057-7.559 6.549h-5.15V8.437ZM19.78 19.782h2.813v5.625H19.78v-5.625Zm11.25 19.782h-14.49c.969-2.735-1.07-5.626-3.979-5.626H11.25V19.782h5.719v7.032c0 .776.63 1.406 1.406 1.406H24c.777 0 1.406-.63 1.406-1.407v-7.03h5.625v19.78ZM33.844 22.5v-1.771a5.56 5.56 0 0 0 3.453-4.769 3.954 3.954 0 0 0 3.424-1.611l1.56-2.127V22.5h-8.437Z"
                      fill="#D87D4A"
                    />
                  </svg>

                  <p>
                    The ‘Cash on Delivery’ option enables you to pay in cash
                    when our delivery courier arrives at your residence. Just
                    make sure your address is correct so that your order will
                    not be cancelled.
                  </p>
                </section>
              </section>
            </form>
            <section className={classes.summary}>
              <h2>Summary</h2>
              <section className={classes.bought_items}>
                <div className={classes.bought_item}>
                  <section
                    className={`${classes.product_left_sec} ${classes.firstItem}`}
                  >
                    <img src={marktwoImg} alt="Mark II" />
                    <div className={classes.product_spans}>
                      <span className={classes.product_name}>XX99 MK II</span>
                      <span className={classes.price_value}> $2,999</span>
                    </div>
                  </section>

                  <span className={classes.qty}>x1</span>
                </div>
                <div className={classes.bought_item}>
                  <section className={classes.product_left_sec}>
                    <img src={xx59ImgItem} alt="" />
                    <div className={classes.product_spans}>
                      <span className={classes.product_name}>XX59</span>
                      <span className={classes.price_value}>$899</span>
                    </div>
                  </section>

                  <span className={classes.qty}>x2</span>
                </div>
                <div className={classes.bought_item}>
                  <section className={classes.product_left_sec}>
                    <img src={earphoneYX1} alt="YX1 earphone" />{" "}
                    <div className={classes.product_spans}>
                      <span className={classes.product_name}>YX1</span>
                      <span className={classes.price_value}>$599</span>
                    </div>
                  </section>

                  <span className={classes.qty}>x1</span>
                </div>
              </section>
              <section className={classes.lower_section}>
                <div
                  className={`${classes.bought_items_info} ${classes.total}`}
                >
                  <span className={classes.price_title}>Total</span>
                  <span>$5,396</span>
                </div>
                <div
                  className={`${classes.bought_items_info} ${classes.shipping}`}
                >
                  <span className={classes.price_title}>Shipping</span>
                  <span>$ 50</span>
                </div>
                <div className={`${classes.bought_items_info} ${classes.vat}`}>
                  <span className={classes.price_title}>VAT</span>
                  <span>$1079</span>
                </div>
                <div
                  className={`${classes.bought_items_info} ${classes.grand_total}`}
                >
                  <span className={classes.price_title}>Grand total</span>{" "}
                  <span className={classes.grandTotalPrice}>$5,526</span>
                </div>
              </section>

              <button type="submit">
                {" "}
                <Link to="/successmodal" className={classes.continueAndPay}>
                  Continue & pay
                </Link>
              </button>
            </section>
            {/* <!-- Cart Modal --> */}
          </section>
          <Footer />
        </section>
      </main>
    </section>
  );
};

export default CheckoutForm;
